import * as React from 'react';
import { ContractListData } from 'tree-wallet-client';
import { Table, Typography } from 'antd';
import { Link } from 'react-router-dom';

const { Text } = Typography;

interface AdminContractsTableProps {
  list?: ContractListData[];
  onUpdate: Function;
  mode: 'desktop'|'mobile';
}

export default class AdminContractsTable extends React.Component<AdminContractsTableProps, any>{
  constructor(props: AdminContractsTableProps) {
    super(props);
    this.state = {}
  }

  getActionColumn() {
    return {
      title: 'Actions',
      key: 'actions' + this.constructor.name,
      render: (text: any, record: any) => {
        return [
          <div key={'3'}>
            <Link to={`/admin/contracts/edit/${record.id}`}>Edit</Link>
          </div>
        ]
      }
    }
  }

  getMobileColumns() {
    return [
      {
        title: 'User details',
        key: 'details',
        render: (text: any, record: any) => {
          return (
            <div key={`${record.id}_ID`}>
              <div key={`${record.id}_ID`}><Text strong>ID</Text> {record.id}</div>
              <div key={`${record.id}_DESCRIPTION`}><Text strong>Desc</Text> {record.description}</div>
              <div key={`${record.id}_TREES`}><Text strong>Trees</Text> {record.treeCount}</div>
            </div>
          );
        }
      },
      this.getActionColumn()
    ]
  }

  getDesktopColumns() {
    return [
      {
        title: 'Description',
        dataIndex: 'description',
        render: (text: any, record: any) => {
          return (
            <div key={`${record.id}_description`}>
              {record.description} (<Text strong>ID {record.id}</Text>)
            </div>
          );
        }
      },
      {
        title: 'Land Owner',
        dataIndex: 'landOwner',
        render: (text: any, record: any) => {
          const landOwner = record.contractUsers?.filter((user: any) => user.owner)[0];
          if (!landOwner) {
            return null;
          }
          return (
            <div>
              <div>{landOwner.firstName} {landOwner.lastName}</div>
              <div>({landOwner.email})</div>
            </div>
          )
        }
      },
      {
        title: 'Tree Planters',
        dataIndex: 'treePlanters',
        render: (text: any, record: any) => {
          const treePlanters = record.contractUsers?.filter((user: any) => !user.owner);
          if (!treePlanters) {
            return null;
          }
          return treePlanters.length ? treePlanters.length : 0;
        }
      },
      {
        title: 'Trees',
        dataIndex: 'trees',
        render: (text: any, record: any) => {
          return <div>{record.treeCount}</div>
        }
      },
      this.getActionColumn()
    ]
  }

  render() {
    const { list, mode } = this.props;

    if (!list || list.length === 0) {
      return <h3>No user on this contract</h3>;
    }

    return <Table
      columns={mode === 'mobile' ? this.getMobileColumns() : this.getDesktopColumns()}
      dataSource={list}
      rowKey={'id'}
    />;
  }
}
